<script lang="ts" setup>
import type { MulticardProductListingData } from '~/types/Catalog';

const { pageData } = defineProps<{ pageData: MulticardProductListingData }>();

const route = useRoute();
const seoText = computed(() => getCatalogSeoText(pageData.product.seo_data));
const seoDescription = computed(() => getCatalogSeoDescription(pageData.product.seo_data));

useHead({
  title: pageData.product.seo_data.title,
  meta: [
    { name: 'description', content: pageData.product.seo_data.description },
    { property: 'og:title', content: pageData.product.seo_data.title },
    { property: 'og:description', content: pageData.product.seo_data.description },
    { property: 'og:type', content: 'product.group' },
    { property: 'og:url', content: route.fullPath },
    { property: 'og:site_name', content: 'Wtfish.ru' },
    { property: 'og:locale', content: 'ru_RU' },
    { property: 'og:image', content: pageData.offers[0]?.offer_images[0]?.url },
  ],
});
</script>

<template>
  <section class="multicard-product-listing-page">
    <CatalogBreadcrumbsBlock :breadcrumbs="pageData.breadcrumbs" />

    <div class="flex items-center gap-2">
      <BackButton />

      <h1>{{ pageData.product.seo_data.header || pageData.product.name }}</h1>
    </div>

    <ProductsListing
      :active-filters="[]"
      :offers="pageData.offers"
      :pagination="pageData.pagination"
    />

    <FoldingTextBlock
      v-if="seoText"
      :max-length="220"
      :text="seoText"
      class="text-sm"
    />

    <div
      v-else-if="seoDescription"
      class="multicard-product-listing-page__seo-description text-sm"
      v-html="seoDescription"
    />
  </section>
</template>

<style lang="scss" scoped>
.multicard-product-listing-page {
  gap: 16px;

  @include inner-content;

  &__seo-description {
    line-height: 1.4;
  }
}
</style>
